<template lang="pug">
  div.main-box(v-show = "isShow")
    Dialog.my-dialog(title="" :visible.sync="isShow" width="540px" center)
        div.dialog-title 开通新课程
        div.text-align-c(v-if="step == 0")
            Row(:gutter="20")
                Col.text-align-l(:span="24")
                    label(style="line-height:40px;") *请输入课程密码：
                Col(:span="24")
                    Input.width-100( v-model="courseCode" placeholder="课程密码为12位，请刮开学习护照涂层查看~")
            Button.submit-btn(class="margin-top-1" type="primary" @click="queryCoursesAndVersion") 确定
        div.text-align-c(v-if="step == 1")
            Row(:gutter="20")
                Col.text-align-r(:span="8")
                    label(style="line-height:40px;") *选定版本：
                Col(:span="12")
                    Select.width-100(
                      placeholder="请选定版本"
                      v-model="version"
                    )
                        Option(
                        v-for='(item, index) in courseAndVersion'
                        :key="item.version"
                        :label="item.version"
                        :value="item.version"
                        )
            Row(:gutter="20")
                Col.text-align-r(:span="8")
                    label(style="line-height:40px;") *课程内容：
                Col(:span="12")
                    div.width-100.margin-top-5
                        div.text-align-l.float-l(
                        v-for="(item, index) in courseList"
                        ) {{item.courseName}}
            Button.submit-btn(class="margin-top-1" type="primary" @click="submitCoursePassword") 确定
</template>

<script>
import {
  Dialog, Button, Input, Message, Option, Select, Row, Col, MessageBox,
} from 'element-ui';
import Course from '@/servers/modules/course/course';

export default {
  name: 'inputCoursesPassword',
  components: {
    Dialog,
    Button,
    Input,
    Message,
    Select,
    Option,
    Row,
    Col,
    MessageBox,

  },
  data() {
    return {
      isShow: false,
      courseCode: '',
      step: 0,
      courseAndVersion: [],
      version: '',
      courseList: [],
    };
  },
  watch: {
    version(val) {
      this.courseAndVersion.forEach((item) => {
        console.log(val, item.version, val == item.version);
        if (val == item.version) this.courseList = item.list;
      });
    },
    isShow(val) {
      if (val == false) {
        this.step = 0;
        this.courseAndVersion = [];
        this.courseList = [];
        this.version = '';
        this.courseCode = '';
      }
    },
  },

  methods: {
    changView() {
      this.isShow = !this.isShow;
    },

    queryCoursesAndVersion() {
      if (!this.courseCode) {
        Message({ message: '请填写课程密码', type: 'error' });
        return false;
      }
      Course.queryCoursesByCoursePass({ courseCode: this.courseCode })
        .then((res) => {
          this.courseAndVersion = res.data.data.packageDetail;
          this.step = 1;
        });
    },
    submitCoursePassword() {
      if (this.courseList.length < 1) {
        Message({ message: '请选择有课程的版本', type: 'error' });
        return false;
      }

      MessageBox.confirm(`您将开通 ${this.version} 相关课程，课程和版本在选定后将不可更改，请谨慎选择!`, '开通课程确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-open-course',
        cancelButtonClass: 'btn-open-course',
        type: 'warning',
      }).then(() => {
        // 清空弹框数据
        this.step = 0;
        this.courseAndVersion = [];

        const courseIds = [];
        this.courseList.forEach((item) => {
          courseIds.push(item.courseId);
        });

        Course.addNewCourse({ courseIds, courseParseWord: this.courseCode })
          .then((res) => {
            this.courseCode = '';
            this.changView();
            this.$emit('changeCourseData');
            Message({
              type: 'success',
              message: '新课程已开通，快去学习吧~',
            });
          }).catch(() => {
            this.step = 0;
            this.courseAndVersion = [];
            this.courseList = [];
            this.version = '';
            this.courseCode = '';
          });
      }).catch(() => {
        Message({
          type: 'info',
          message: '已取消操作',
        });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.text-align-c
    text-align center
.text-align-l
    text-align left
.float-l
    float: left
    margin-right 10px
.text-align-r
    text-align right
.margin-top-1
    margin-top: 10%
.margin-top-5
    margin-top 3%
.width-60
    width 60%
.width-100
    width 100%
</style>

<style lang="stylus">
.select-choose
  .el-select-dropdown__item
    height 46px
</style>

// 弹窗
<style lang="stylus" scoped>
.main-box
  // position relative
  >>> .el-dialog
    box-shadow none
    border-radius 16px
  >>> .el-dialog__header
    .el-dialog__close
      display none
  >>> .el-dialog__body
    padding 25px 70px 30px
  .dialog-title
    position: absolute;
    top: -18px;
    left: calc(50% - 80px)
    width: 160px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #1884FF;
    box-shadow: 0px 0px 4px 2px rgba(32, 32, 32, 0.24);
    border-radius: 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  .submit-btn
    width: 160px;
    height: 40px;
    background: #1884FF;
    border-radius: 20px;
</style>
